import React, { useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useFlow } from '../hooks/useFlow';

interface Props {
  flowName: string;
  clinicName?: string;
}

function Header({ flowName, clinicName }: Props) {
  const { flow, setFlow } = useFlow();
  const [clickCount, setClickCount] = useState(0);

  // 施設ID入力画面に遷移
  const handleLogoClick = () => {
    setClickCount((prevCount) => {
      const newCount = prevCount + 1;

      if (newCount >= 3) {
        setFlow('facilityInput');
        return 0;
      }

      return newCount;
    });
  };

  const handleClick = () => {
    setFlow('top');
  };
  return (
    <header className="sticky left-0 top-0 ">
      <div className="relative left-1/2 -translate-x-1/2 w-screen bg-primary py-4">
        <img
          src="/images/logo.svg"
          width={40}
          height={40}
          alt="ロゴ"
          className="absolute top-3 left-4 cursor-pointer"
          onClick={handleLogoClick}
        />
        <h1 className="text-white font-semibold text-3xl text-center" style={{ minHeight: '37px' }}>
          {flowName || '\u00A0'}
        </h1>
      </div>
      {(flow === 'QRcodeReader' ||
        flow === 'inputNumber' ||
        flow === 'LINEFriendAdd' ||
        flow === 'error' ||
        clinicName) && (
        <div className="relative left-1/2 -translate-x-1/2 w-screen bg-white border-b-2 py-2 text-sm">
          {flow === 'QRcodeReader' || flow === 'inputNumber' || flow === 'LINEFriendAdd' || flow === 'error' ? (
            <button className="absolute left-4 flex items-center" onClick={handleClick}>
              <ArrowBackIosIcon className="w-4 h-4 text-primary" />
              <p className="text-primary">戻る</p>
            </button>
          ) : null}
          {clinicName && <h2 className="text-center">{clinicName}</h2>}
        </div>
      )}
    </header>
  );
}

export default Header;
